module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Chernobyl-S1.908f0a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Chernobyl-S1.jpg
// module id = w6GF
// module chunks = 0